import { useState, useRef, useEffect } from 'react'
import { ALL_COLUMNS, getDefaultVisible } from './columnConfig'

export default function ColumnSelector({ visible, onChange }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const toggleColumn = (colId) => {
    const updated = visible.includes(colId)
      ? visible.filter(id => id !== colId)
      : [...visible, colId]
    onChange(updated)
  }

  const toggleable = ALL_COLUMNS.filter(c => !c.fixed)

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="px-2 py-1 text-xs text-gray-500 dark:text-gray-400 bg-white dark:bg-surface-dark-alt border border-gray-200 dark:border-surface-dark-border rounded-md hover:bg-gray-50 dark:hover:bg-surface-dark-hover flex items-center gap-1"
      >
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
        </svg>
        Columnas
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white dark:bg-surface-dark-alt border border-gray-200 dark:border-surface-dark-border rounded-lg shadow-lg p-3 z-50 min-w-[160px]">
          <div className="text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">Columnas visibles</div>
          {toggleable.map(col => (
            <label key={col.id} className="flex items-center gap-2 py-0.5 cursor-pointer text-xs text-gray-700 dark:text-gray-300">
              <input
                type="checkbox"
                checked={visible.includes(col.id)}
                onChange={() => toggleColumn(col.id)}
                className="rounded border-gray-300 dark:border-slate-600 text-primary-500 focus:ring-primary-500"
              />
              {col.label || col.id}
            </label>
          ))}
          <button
            onClick={() => onChange(getDefaultVisible())}
            className="mt-2 pt-2 border-t border-gray-100 dark:border-surface-dark-border text-[10px] text-primary-500 hover:text-primary-600 w-full text-left"
          >
            Restaurar default
          </button>
        </div>
      )}
    </div>
  )
}
